import { CampaignStatus } from "@/enum/campaign-status.enum";

import { List } from "../../schema/list";

/**
 * Status-dot tone for a list row, derived from the list's single `campaignStatus`.
 * The lean-list endpoint exposes one campaign status per list (not a per-campaign array),
 * so we collapse it to the mockup's three visual tones.
 */
export type ListStatusTone = "active" | "paused" | "none";

export const getListStatusTone = (campaignStatus?: CampaignStatus | null): ListStatusTone => {
	if (campaignStatus === CampaignStatus.RUNNING) {
		return "active";
	}

	if (campaignStatus === CampaignStatus.PAUSED) {
		return "paused";
	}

	return "none";
};

/**
 * "assigned/total" count shown on a row. The lean DTO gives `processed` (non-draft, i.e. handled)
 * and `found` (total added); we render `processed/found`. Returns null when there is nothing to show.
 */
export const formatAssignedCount = (list: Partial<List>): string | null => {
	const total = list.found ?? 0;

	if (!total) {
		return null;
	}

	return `${list.processed ?? 0}/${total}`;
};
